import React from "react";
import exclusive_image from "./Assets/exclusive_image.png";
import offers from "../css/offers.css";

const Offers = () => {
  return (
    <div style={offers} className="offers">
      <div className="offers-left">
        <h1>Exclusive</h1>
        <h1>Offers For You</h1>
        <p>ONLY ON BEST SELLER PRODUCT</p>
        <button>Check Now</button>
      </div>
      <div className="offers-right">
        <img src={exclusive_image} alt="fashion" />
      </div>
    </div>
  );
};

export default Offers;
